"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.baseColors = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var baseColors = {
  // Color Definitions
  black: '#000000',
  white: '#ffffff',
  red: '#d52b1e',
  charcoal: '#454545',
  green: '#00ac3e',
  blue: '#0088ce',
  yellow: '#ffbc3d',
  orange: '#ed7000',
  coolGray1: '#f6f6f6',
  coolGray3: '#d8dada',
  coolGray6: '#747676',
  coolGray10: '#333333',
  grayLight: '#d8dada'
};
exports.baseColors = baseColors;
var textColors = {
  textColor: baseColors.charcoal,
  textColorSuccess: baseColors.white,
  textColorInfo: baseColors.white,
  textColorWarning: baseColors.charcoal,
  textColorError: baseColors.white
};

var _default = _objectSpread(_objectSpread({}, baseColors), textColors);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/theme/dist/cjs/verizonTheme/colors.js
// module id = 550
// module chunks = 0